<template>
  <div class="email-preference" v-loading="channelsLoading">
    <div class="flex preference-description">
      <div class="box grow">
        <div class="slack-div">
          <img src="/static/images/slack.svg" alt="slack logo" />
          <div class="slack-header">
            <div style="font-weight:bold;">Slack Preferences</div>
            <div>Configure Slack notifications you’d like to receive from Confluera.</div>
          </div>
        </div>
        <div class="slack-notification-title">
          Turn On Slack
        </div>
      </div>
    </div>
    <div 
      class="preference-settings" 
      v-if="userSlackNotificationPreferenceStatus === 'saved'"
    >
      <div class="box grow flex column">
        <div class="box grow flex">
          <div class="box grow">
            <el-switch
              class="notification-switch"
              v-model="slackPreference.subscribed"
              @change="handleCheckAllChange"
            >
            </el-switch>
            <span class="text-format">
              {{ userAccount.getSlackNotificationPreferencesText('subscribed') }}
            </span>
          </div>
        </div>

        <div style="display:flex;">
          <el-checkbox-group
            class="slack-channels-container"
            v-model="selectedChannels"
            @change="handleChannelSelectionChange"
          >
            <el-checkbox v-for="channel in channelList" :label="channel.webhook_url" :key="channel.webhook_url">
              <span class="text-format">
                {{ channel.webhook_name }}
              </span>
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="divider">
          <el-divider></el-divider>
        </div>
        <div class="notification-preferences-title">Confluera Notifications</div>
        <div class="box grow block">
          <div style="margin: 13px 0 9px 74px;">
            <span class="text-format mb-10">Threat Progressions</span>
          </div>
          <div class="box grow ml-74">
            <div
              class="box"
              v-for="(value, name) in slackPreference.trail"
              :key="name"
              :class="{ 'display-none': name.includes('increment') }"
            >
              <el-checkbox class="mb-7" v-model="slackPreference.trail[name]" @change="handlePrefChanges">
                <span class="text-format">
                  {{ userAccount.getSlackNotificationPreferencesText(name) }}
                </span>
              </el-checkbox>
            </div>
          </div>
        </div>
        <div class="box grow block">
          <div style="margin: 13px 0 9px 74px;">
            <span class="mb-10">Hosts</span>
          </div>
          <div class="box grow ml-74">
            <div
              class="box"
              v-for="(value, name) in slackPreference.host"
              :key="name"
              :class="{ 'display-none': name.includes('increment') }"
            >
              <el-checkbox class="mb-7" v-model="slackPreference.host[name]" @change="handlePrefChanges">
                <span class="text-format">
                  {{ userAccount.getSlackNotificationPreferencesText(name) }}
                </span>
              </el-checkbox>
            </div>
          </div>
        </div>
        <div class="divider">
          <el-divider></el-divider>
        </div>
        <div class="button-container">
          <el-button class="help-btn">
            <span class="help-btn-txt" @click="loadDocumentation('page-slack-preference')">User Guide</span>
          </el-button>
          <el-button class="save-btn" @click="udpateSlackNotificationPreferences">
            <span class="save-btn-txt">Save and Submit</span>
          </el-button>
        </div>
      </div>
    </div>

    <el-divider></el-divider>
    <div class="box grow flex float-right footer">
      <el-button
        v-if="$_.has(slackPreference, 'slack_channels')"
        type="text"
        class="icon-text-button"
        @click="udpateSlackNotificationPreferences"
      >
        <i class="material-icons c-icon">save</i>
        <span>Save</span>
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import {
  SLACK_NOTIFICATION_PREFERENCE_REQUEST,
  SLACK_NOTIFICATION_PREFERENCE_UPDATE_REQUEST
} from '@/store/modules/user/slack-preference.type'

import { SLACK_SETTING_REQUEST } from '@/store/modules/slack/slack-setting.type'
import loadDocumentationMixin from '@/mixins/loadDocumentationMixin'

export default {
  name: 'EmailPreference',
  mixins: [loadDocumentationMixin],
  data() {
    return {
      slackPreference: {},
      selectedChannels: [],
      channelList: [],
      channelsLoading: true
    }
  },
  methods: {
    getChannelList() {
      this.$store.dispatch(SLACK_SETTING_REQUEST).then(resp => {
        this.channelList = this.slackSettings.models
        this.channelsLoading = false;
      }, _ => {
        this.channelsLoading = false;
      })
    },
    handleCheckAllChange(val) {
      let prefs = ['trail', 'host']
      for (let prefVal in prefs) {
        this.checkPreferenceObj(this.slackPreference, prefs[prefVal], val)
      }
    },
    checkPreferenceObj(preferences, prefKey, val) {
      for (let key in preferences[prefKey]) {
        if (key.includes('increment')) {
          continue
        }
        preferences[prefKey][key] = val
      }
    },
    handlePrefChanges(val) {
      // if all preferences are unchecked, unsubscribed to email notification
      let prefs = ['trail', 'host']
      let toSubscribe = false
      for (let prefVal in prefs) {
        toSubscribe = this.anyPreferenceChecked(this.slackPreference, prefs[prefVal])
        if (toSubscribe) {
          this.slackPreference.subscribed = toSubscribe
          return true
        }
      }
      this.slackPreference.subscribed = toSubscribe
    },
    anyPreferenceChecked(preferences, prefKey) {
      for (let pref in preferences[prefKey]) {
        if (pref.includes('increment')) {
          continue
        }
        if (preferences[prefKey][pref]) {
          return true
        }
      }
      return false
    },
    getSlackNotificationPreferences() {
      this.$store.dispatch(SLACK_NOTIFICATION_PREFERENCE_REQUEST).then(
        preferences => {
          this.slackPreference = _.cloneDeep(_.omit(this.userAccount.notificationSlackPreferences, 'user_acct'))
            
          if (_.has(this.slackPreference, 'slack_channels')) {
            this.slackPreference.slack_channels.forEach((channel, idx) => {
              this.selectedChannels.push(channel.channel_hook)
            })
          }
        },
        error => {
          console.log(error)
        }
      )
    },
    udpateSlackNotificationPreferences() {
      this.$store
        .dispatch(SLACK_NOTIFICATION_PREFERENCE_UPDATE_REQUEST, {
          subscribed: this.slackPreference.subscribed,
          hostRiskChange: this.slackPreference.host.host_risk_change,
          hostStatusChange: this.slackPreference.host.host_status_change,
          trailAssignmentChange: this.slackPreference.trail.trail_assignment_change,
          trailProgression: this.slackPreference.trail.trail_progression,
          trailRiskChange: this.slackPreference.trail.trail_risk_change,
          trailStatusChange: this.slackPreference.trail.trail_status_change,
          selectedChannelslist: this.selectedChannels
        })
        .then(
          preferences => {
            this.$message({
              type: 'success',
              message: 'Slack notification preferences were successfully saved.'
            })
          },
          errMsg => {
            this.$message({
              type: 'error',
              message: `Unable to save slack notification preferences.`
            })
          }
        )
    },
    handleChannelSelectionChange(val) {
      this.selectedChannels = val
    }
  },
  created() {
    this.getChannelList()
    this.getSlackNotificationPreferences()
  },
  computed: {
    ...mapGetters(['userSlackNotificationPreferenceStatus', 'userAccount', 'slackSettings'])
  },
  components: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import 'assets/styles/_variables.css';

.preference-description {
  > .box:first-of-type {
    margin-right: 50px;
  }
}

.preference-settings {
  overflow: scroll;
  height: calc(100vh-310px);

  .title {
    min-width: 200px;
  }
}

.slack {
  font-size: 6em;
}

.category-title {
  float: right;
  margin-right: 30px;
}

.icon-text-button {
  background: var(--main-blue);
  padding: 5px 10px;

  span {
    .c-icon {
      color: white;
      font-size: 1.2em;
      vertical-align: text-bottom;
      margin-right: 5px;
    }
    span {
      color: white;
      margin-bottom: 6px;
    }
  }
}

.c-icon {
  border: 1px solid;
  border-radius: 50%;
}

.add-button {
  vertical-align: middle;
  line-height: 50px;
  margin-left: 5px;
}
.slack-header {
  margin-top: 0px;
  margin-left: 22px;
  display: block;
  height: 60px;
  width: 426px;
  color: #292c32;
  font-size: 13px;
  letter-spacing: 0;
  line-height: 20px;
}

.slack-div {
  margin: 31px 0px 0px 11px;
  display: flex;
}

.help-btn {
  height: 36px;
  width: 133px;
  color: #767676;
  background-color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.1px;
  line-height: 20px;
  text-align: center;
  border: 1px solid #767676;
  box-sizing: border-box;
  border-radius: 4px;
  padding-bottom: 9px;
  padding-top: 7px;
}

.help-btn-txt {
  height: 20px;
  width: 117px;
  color: #767676;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.1px;
  line-height: 20px;
  text-align: center;
}

.save-btn {
  height: 36px;
  width: 167px;
  border-radius: 4px;
  background-color: #1a90fa;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.1px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding-bottom: 9px;
  padding-top: 7px;
}

.save-btn-txt {
  height: 20px;
  width: 114px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.1px;
  line-height: 20px;
  text-align: center;
}

.slack-notification-title {
  margin: 24px 0 19px 74px;
  height: 20px;
  width: 94px;
  color: #292c32;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 20px;
}

.notification-preferences-title {
  margin-left: 74px;
  height: 20px;
  width: 94px;
  color: #292c32;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 20px;
  white-space: nowrap;
}

.text-format {
  height: 60px;
  width: 426px;
  color: #292c32;
  font-size: 13px;
  letter-spacing: 0;
  line-height: 20px;
}

.notification-switch {
  height:22px;
  width:57px;
  margin-left:74px;
}

.slack-channels-container { 
  margin:30px 0 0 77px;
  width:70%
}

.divider {
  margin-left: 74px;
  max-width: 65%
}

.button-container { 
  display:flex;
  margin-left:50%;
  margin-bottom: 48px;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/SlackPreference.vue